const de = {
  app: {
    name: "Firstier Admin",
  },
  shell: {
    groupOverview: "Übersicht",
    groupData: "Website-Daten",
    groupOnboarding: "Onboarding",
    groupGrowth: "Growth",
    groupPlayground: "Playground",
    groupAdmin: "Admin",
    nav: {
      dashboard: "Dashboard",
      customers: "Kunden",
      users: "Nutzer",
      revenue: "Umsatz",
      usage: "Nutzung",
      agents: "Agenten",
      newsletter: "Newsletter",
      applications: "Bewerbungen",
      leads: "Leads",
      gated: "Gated Content",
      downloadNotify: "Download-Interessenten",
      helpFeedback: "Hilfe-Feedback",
      invites: "Offene Einladungen",
      accessRequests: "Zugangsanfragen",
      signupCodes: "Signup-Codes",
      seo: "SEO",
      keywords: "Keywords",
      questions: "Fragen",
      reviewHub: "Review-Hub",
      members: "Mitglieder",
      settings: "Einstellungen",
      dataTypes: "Datentypen",
    },
    collapseSidebar: "Seitenleiste einklappen",
    expandSidebar: "Seitenleiste ausklappen",
    expandNav: "Navigation öffnen",
    toggleTheme: "Design wechseln",
    signOut: "Abmelden",
    accountMenu: "Kontomenü",
    searchPlaceholder: "Suchen",
    commandMenu: {
      navigation: "Navigation",
    },
  },
  common: {
    unnamed: "Benutzer",
    yes: "Ja",
    no: "Nein",
  },
  auth: {
    title: "Firstier Admin",
    subtitle: "Interner Admin-Zugang. Nur für Mitarbeitende.",
    emailLabel: "E-Mail",
    emailPlaceholder: "du@firstier.ai",
    passwordLabel: "Passwort",
    signIn: "Anmelden",
    signingIn: "Anmeldung läuft…",
    signedOut: "Du wurdest abgemeldet.",
    notAuthorizedTitle: "Nicht berechtigt",
    notAuthorizedBody: "Dieses Konto ist nicht für die Console freigegeben. Melde dich mit deinem Firstier-Mitarbeiterkonto an.",
    genericError: "Anmeldung fehlgeschlagen. Bitte Zugangsdaten prüfen und erneut versuchen.",
    forgotPassword: "Passwort vergessen?",
    forgotSubtitle: "Gib deine E-Mail ein, wir senden dir einen Reset-Link.",
    sendResetLink: "Reset-Link senden",
    resetSent: "Falls ein Konto zu dieser E-Mail existiert, ist ein Reset-Link unterwegs.",
    backToSignIn: "Zurück zur Anmeldung",
    resetTitle: "Neues Passwort wählen",
    resetInvalid: "Dieser Reset-Link ist ungültig oder abgelaufen.",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordMismatch: "Passwörter stimmen nicht überein.",
    setNewPassword: "Passwort setzen",
    resetUpdated: "Passwort aktualisiert.",
    resetUpdateError: "Passwort konnte nicht aktualisiert werden. Bitte Reset-Link erneut nutzen.",
  },
  table: {
    empty: "Noch nichts vorhanden.",
    error: "Daten konnten nicht geladen werden.",
    emptyTitle: "Noch keine Daten",
    emptyDesc: "Hier gibt es noch nichts anzuzeigen. Neue Einträge erscheinen automatisch.",
    truncatedWarning: "Sehr großer Datenbestand — nur die ersten 20.000 Zeilen werden geladen; ältere Zeilen fehlen.",
    noResultsTitle: "Keine Treffer",
    noResultsDesc: "Keine Zeile passt zu deiner Suche oder deinen Filtern. Bitte anpassen.",
  },
  dash: {
    inbound30d: "Eingang — letzte 30 Tage",
    appsByStatus: "Bewerbungen nach Status",
    customersByPlan: "Kunden nach Plan",
  },
  agents: {
    env: { staging: "Staging-Daten", production: "Produktivdaten" },
    killStatus: "Kill-Switch",
    killActive: "Kill aktiv",
    killInactive: "Läuft",
    epoch: "Epoche {{epoch}}",
    killReason: "Grund: {{reason}}",
    budget: {
      title: "Budget {{month}}",
      cap: "Limit {{cap}} / Monat",
      estimated: "Geschätzt (abgerechnet + reserviert)",
      invoiced: "In Rechnung gestellt",
      allowance: "Enthält die Position variable Infrastruktur ({{amount}}).",
    },
    leases: "Lease-Bestätigungen",
    lease: { holder: "Inhaber", ack: "Status", epoch: "Gesehene Epoche", lastAck: "Letzte Bestätigung" },
    ack: {
      "acknowledged-stop": "Stopp bestätigt",
      "unknown-unreachable": "Unbekannt / nicht erreichbar",
      running: "Läuft",
    },
    registry: "Agenten-Register",
    runs24h: "Läufe, letzte 24 h",
    col: { agent: "Agent", version: "Version", org: "Organisation", state: "Status", lastRun: "Letzter Lauf", started: "Gestartet", cost: "Kosten" },
    agentState: { active: "Aktiv", paused: "Pausiert", disabled: "Deaktiviert" },
    runState: { queued: "Wartet", running: "Läuft", succeeded: "Erfolgreich", failed: "Fehlgeschlagen", killed: "Beendet" },
    pause: "Pausieren",
    resume: "Fortsetzen",
    cancel: "Abbrechen",
    paused: "{{name}} pausiert.",
    resumed: "{{name}} fortgesetzt.",
    pauseDialog: {
      title: "{{name}} pausieren?",
      description: "Der Agent nimmt keine neue Arbeit an, bis er fortgesetzt wird. Bereits laufende Läufe werden nicht unterbrochen.",
      reason: "Grund (optional)",
    },
    kill: {
      button: "Kill",
      title: "Alle Agenten beenden?",
      description: "Erhöht die Kill-Epoche. Alle Agenten und die Lease der lokalen Flotte lehnen neue Arbeit ab, bis der Kill außerhalb dieser Oberfläche aufgehoben wird.",
      reason: "Grund (erforderlich)",
      confirm: "Alle Agenten beenden",
      done: "Kill-Epoche erhöht.",
    },
    notReady: "Das Schema der Agenten-Plattform ist noch nicht live.",
    actionError: "Die Aktion ist fehlgeschlagen. Es wurde nichts geändert.",
  },
  usage: {
    metric: {
      users_total: "Nutzer",
      sessions_valid: "Sessions gültig",
      web_online_now: "Web jetzt online",
      desktop_online_now: "Desktop jetzt online",
      web_active_24h: "Web aktiv (24h)",
      ext_active_24h: "Extension aktiv (24h)",
    },
    funnel: {
      users_total: "Nutzer",
      ext_connected: "Extension verbunden",
      ext_active_7d: "Extension aktiv (7 Tage)",
      desktop_enrolled: "Desktop registriert",
      desktop_active_24h: "Desktop aktiv (24h)",
    },
    col: {
      org: "Organisation",
      users_total: "Nutzer",
      sessions_valid: "Sessions",
      web_active_24h: "Web 24h",
      web_active_7d: "Web 7T",
      web_online_now: "Web jetzt",
      ext_connected: "Ext verbunden",
      ext_active_24h: "Ext 24h",
      ext_active_7d: "Ext 7T",
      desktop_enrolled: "Desktop registriert",
      desktop_active_24h: "Desktop 24h",
      desktop_online_now: "Desktop jetzt",
    },
    hint: {
      sessions_valid: "Nicht abgelaufene Anmelde-Sessions (session-valid) — kein Online-jetzt-Zähler.",
      ext_connected: "Nutzer, deren Extension sich mindestens einmal angemeldet hat — eine installierte, aber nie angemeldete Extension ist unsichtbar.",
      online_now: "Aktiv in den letzten 5 Minuten. Nutzer mit Presence-Schutz sind ausgenommen.",
    },
    funnelTitle: "Adoptions-Funnel",
    byOrg: "Nach Organisation",
    generatedAt: "Datenstand {{time}}",
  },
  revenue: {
    arr: "ARR",
    source: "Stripe · Firstier AI Governance GmbH",
    gross: "Brutto",
    rangeLabel: "Zeitraum",
    rangePreset: {
      last30: "Letzte 30 Tage",
      mtd: "Monat bis heute",
      qtd: "Quartal bis heute",
      ytd: "Jahr bis heute",
      last90: "Letzte 90 Tage",
      custom: "Eigener Zeitraum",
    },
    snapshotHint: "Momentaufnahme — der Zeitraum greift hier nicht.",
    truncatedWarning: "Ergebnis gekappt: Die Zahlungsliste hat das Pagination-Limit erreicht — Summen können zu niedrig sein.",
    fxHintAed: "Umgerechnet über den USD-Peg (3,6725 AED/USD) auf Basis des EZB-Referenzkurses (Stand {{date}}).",
    fxHint: "Umgerechnet zum EZB-Referenzkurs (Stand {{date}}).",
    currencySwitch: "Anzeigewährung",
    oob: "Überweisung (out of band)",
    mrr: "MRR",
    activeSubs: "Aktive Abos",
    gross30d: "Brutto — letzte 30 Tage",
    available: "Verfügbares Guthaben",
    amount: "Betrag",
    recent: "Letzte Zahlungen",
  },
  seo: {
    tabUrls: "URLs",
    tabKeywords: "Keywords",
    tabQuestions: "Fragen",
    trend: "Durchschnittsposition im Zeitverlauf",
    avgPosition: "Ø Position",
    notRanked: "Nicht in Top 30",
    accept: "Übernehmen",
    proposalAccepted: "Vorschlag als Fokus-Keyword übernommen.",
    focusPlaceholder: "Fokus-Keyword festlegen…",
    rankedQueryTip: "Die Google Search Console verbirgt Suchanfragen unterhalb einer Mindest-Impression-Schwelle, daher kann dies leer sein.",
    searchVolumeTip: "Geschätztes monatliches Suchvolumen aus den Bing Webmaster Tools.",
    searchVolumeEst: "geschätzt (Bing)",
    countBadge: "{{count}} Keywords",
    edit: "Bearbeiten",
    noFocus: "Kein Fokus gesetzt",
    slideoutTitle: "SEO-Ziel bearbeiten",
    focusHint: "Lege das bewusst gewählte Fokus-Keyword für diese URL fest. Leer lassen, um es zu entfernen.",
    focusSourceLabel: "Fokus-Quelle",
    focusSource: {
      agent_proposed: "Agent-Vorschlag",
      accepted: "Übernommen",
      human_override: "Manuell gesetzt",
    },
    filterLang: "Sprache",
    langAll: "Alle Sprachen",
    langEn: "Englisch",
    langDe: "Deutsch",
    metaSectionTitle: "Meta-Tags",
    metaTitle: "Meta-Titel",
    metaTitlePlaceholder: "Seitentitel für Suchergebnisse…",
    metaDescription: "Meta-Beschreibung",
    metaDescriptionPlaceholder: "Zusammenfassung unter dem Titel in den Suchergebnissen…",
    ogImage: "OG-Bild",
    ogImagePlaceholder: "https://…",
    ogImagePreviewAlt: "OG-Bild-Vorschau",
    overridden: "Überschrieben",
    currentlyLive: "Aktuell live: {{value}}",
    metaApplyHint:
      "Unveränderte Felder behalten den Live-Wert; ein bearbeiteter Wert wird beim nächsten SEO-Lauf übernommen.",
    healthTitle: "Technische SEO-Gesundheit",
    healthFailures: "{{count}} Fehler",
    healthPages: "Geprüfte Seiten",
    healthLinks: "Geprüfte Links",
    healthFailuresStat: "Fehler",
    healthTarget: "Ziel",
    healthCrawledAt: "Letzter Crawl: {{at}}",
    healthEmpty: "Noch kein Crawl — der technische SEO-Crawler füllt dies, sobald er läuft.",
    regressionsTitle: "Verschlechterungen",
    regressionsBadge: "{{count}} markiert",
    regressionsEmpty: "Keine Verschlechterungen gegenüber dem Vorzeitraum. 🎉",
    topQueriesTitle: "Top-Suchanfragen",
    topQueriesBadge: "Top {{count}}",
  },
  seoCol: {
    url: "URL",
    focus: "Fokus-Keyword",
    rankedQuery: "Ranking-Suchanfrage (GSC)",
    proposed: "Vorschlag (Agent)",
    position: "Position",
    change: "Veränderung",
    impressions: "Impressionen",
    clicks: "Klicks",
    searchVolume: "Suchvolumen",
    query: "Suchanfrage",
    ctr: "CTR",
    tip: {
      url: "Die getrackte Seiten-URL auf der Website.",
      focus: "Das aktuell dieser Seite zugewiesene Fokus-Keyword.",
      rankedQuery: "Top-Suchanfrage, für die die Seite in der Google Search Console rankt — unterhalb einer niedrigen Impressionsschwelle nicht ausgewiesen, daher ggf. leer.",
      proposed: "Vom Agenten vorgeschlagenes Fokus-Keyword, noch zu prüfen.",
      position: "Durchschnittliche Google-Position (1 = oben); niedriger ist besser.",
      change: "Positionsänderung gegenüber dem Vorzeitraum.",
      impressions: "Wie oft die Seite in den Suchergebnissen erschien.",
      clicks: "Klicks aus den Suchergebnissen auf die Seite.",
      searchVolume: "Geschätztes monatliches Suchvolumen aus den Bing Webmaster Tools.",
      query: "Die von Nutzern eingegebene Suchanfrage.",
      ctr: "Klickrate: Klicks ÷ Impressionen.",
    },
  },
  keywordImport: {
    button: "CSV importieren",
    title: "Keyword-CSV importieren",
    description: "Laden Sie einen ATP- oder Sistrix-Keyword-Export hoch. Zeilen werden dedupliziert und in den Recherche-Bestand übernommen.",
    sourceLabel: "Quellformat",
    sourceAuto: "Automatisch erkennen",
    source: {
      atp_csv: "ATP (CSV)",
      sistrix_csv: "Sistrix (CSV)",
    },
    language: "Sprache",
    languagePlaceholder: "z. B. de",
    country: "Land",
    countryPlaceholder: "z. B. DE",
    file: "CSV-Datei",
    choose: "Datei auswählen…",
    noFile: "Keine Datei ausgewählt",
    import: "Importieren",
    success: "{{upserted}} von {{parsed}} Zeilen importiert.",
    readError: "Die Datei konnte nicht gelesen werden.",
    emptyFile: "Die ausgewählte Datei ist leer.",
  },
  keywords: {
    search: "Keywords suchen…",
    countBadge: "{{count}} Keywords",
    filterLocale: "Sprache/Land",
    filterIntent: "Intent",
    filterScope: "Bereich",
    scopeAll: "Alle Keywords",
    scopeUnassigned: "Nur ohne Zuweisung",
    unassigned: "Ohne Zuweisung",
    questionBadge: "Frage",
    assignLabel: "Ziel-URL",
    assignHint: "Die Seite, für die dieses Keyword ranken soll. Leer lassen, um die Zuweisung aufzuheben.",
    assignPlaceholder: "https://www.firstier.ai/…",
    answeringSection: "People-Also-Ask-Beantwortung",
    answerStatusLabel: "Antwortstatus",
    answerModeLabel: "Antwortmodus",
    answerModeHint: "Primär = Slug/Titel/Meta auf der Seite; sekundär = FAQ-Block.",
    answeredUrlLabel: "Antwort-URL",
    intent: {
      informational: "Informativ",
      commercial: "Kommerziell",
      transactional: "Transaktional",
      navigational: "Navigational",
    },
    answerStatus: {
      none: "Unbeantwortet",
      planned: "Geplant",
      answered: "Beantwortet",
      not_relevant: "Nicht relevant",
    },
    answerMode: {
      unset: "Nicht gesetzt",
      slug_title_meta: "Slug / Titel / Meta (primär)",
      faq: "FAQ-Block (sekundär)",
    },
  },
  keywordsCol: {
    keyword: "Keyword",
    locale: "Sprache/Land",
    intent: "Intent",
    volume: "Volumen",
    cpc: "CPC",
    gscPosition: "GSC-Position",
    assigned: "Ziel-URL",
    topic: "Thema",
    modifier: "Modifikator",
    tip: {
      keyword: "Das Recherche-Keyword, über alle Importquellen zusammengeführt.",
      locale: "Sprach- und Ländermarkt für dieses Keyword.",
      intent: "Suchintention: informational, kommerziell, transaktional oder navigational.",
      volume: "Geschätztes monatliches Suchvolumen (beste verfügbare Quelle).",
      cpc: "Durchschnittlicher Cost-per-Click für dieses Keyword (bezahlte Suche) — für SEA-Planung.",
      gscPosition: "Durchschnittliche Google-Position aus der Search Console (1 = oben); niedriger ist besser.",
      assigned: "Die Seite, für die dieses Keyword ranken soll.",
      topic: "Das Seed-Thema, aus dem dieses Keyword abgeleitet wurde.",
      modifier: "Der Frage-Modifikator (z. B. wie, was, beste) für diese Anfrage.",
    },
  },
  questions: {
    search: "Fragen suchen…",
    countBadge: "{{count}} Fragen",
    filterTopic: "Thema",
    filterStatus: "Status",
    answer: "Beantworten",
  },
  questionsCol: {
    question: "Frage",
    status: "Antwortstatus",
    tip: {
      question: "Das Frage-Keyword im Stil von „Nutzer fragen auch“.",
      status: "Ob diese Frage auf der Website beantwortet ist: unbeantwortet, geplant oder beantwortet.",
    },
  },
  toast: {
    updated: "Gespeichert.",
    updateError: "Änderungen konnten nicht gespeichert werden.",
    cvError: "Der Lebenslauf konnte nicht geöffnet werden.",
  },
  col: {
    email: "E-Mail",
    name: "Name",
    status: "Status",
    category: "Kategorie",
    source: "Quelle",
    sourceCategory: "Quellkategorie",
    created: "Eingegangen",
    confirmed: "Bestätigt",
    platforms: "Plattformen",
    article: "Artikel",
    votes: "Stimmen",
    helpfulPct: "Hilfreich",
    lastVote: "Letzte Stimme",
    comment: "Kommentar",
    role: "Position",
    profile: "Profil",
    cv: "Lebenslauf",
    notes: "Notizen",
    company: "Unternehmen",
    companySize: "Größe",
    useCase: "Use-Case",
    market: "Markt",
    message: "Nachricht",
    plan: "Plan",
    subscription: "Abo",
    members: "Mitglieder",
    domain: "Domain",
    industry: "Branche",
    locale: "Sprache",
    appId: "APP-ID",
    hrStatus: "HR-Status",
    rejectionOn: "Absage am",
    synced: "Letzter Sync",
    dossier: "Dossier",
    correspondence: "Korrespondenz",
  },
  list: {
    search: "Suchen…",
    filterStatus: "Status",
    filterCategory: "Kategorie",
    filterSource: "Quelle",
    filterSourceCategory: "Quellkategorie",
    filterMarket: "Markt",
    filterRole: "Position",
    filterRisk: "Risiko",
    filterPlatform: "Plattform",
    edit: "Ansehen / bearbeiten",
    delete: "Löschen",
    deleteTitle: "Endgültig löschen",
    deleteDesc: "„{{label}}“ wird endgültig gelöscht — das kann nicht rückgängig gemacht werden.",
    deleted: "Gelöscht.",
    countNewsletter: "{{count}} Abonnenten",
    countLeads: "{{count}} Leads",
    countApplications: "{{count}} Bewerbungen",
    countGated: "{{count}} Leads",
    countDownloadNotify: "{{count}} Anmeldungen",
    countHelpFeedback: "{{count}} Stimmen",
    countHelpComments: "{{count}} Kommentare",
    slideoutNewsletter: "Abonnent",
    slideoutLead: "Lead",
    slideoutApplication: "Bewerbung",
  },
  newsletterSource: {
    blog: "Blog",
    guide: "Leitfaden",
    glossary: "Glossar",
    other: "Sonstige",
  },
  helpFeedback: {
    byArticle: "Nach Artikel",
    comments: "Kommentare",
    openArticle: "Artikel öffnen",
    capWarning: "Es werden die neuesten 1.000 Stimmen angezeigt — ältere Stimmen fließen nicht in die Aggregation ein.",
  },
  batch: {
    selected: "{{count}} ausgewählt",
    selectedOnPage: "{{count}} auf dieser Seite ausgewählt",
    clear: "Auswahl aufheben",
    selectAllMatching: "Alle {{count}} Treffer auswählen",
    export: "CSV exportieren",
    delete: "Löschen",
    deleteTitle: "{{count}} Datensätze endgültig löschen",
    deleteDesc: "{{count}} Datensätze werden endgültig gelöscht — das kann nicht rückgängig gemacht werden. Zum Bestätigen {{word}} eingeben.",
    confirmWord: "LÖSCHEN",
    deleted: "{{count}} gelöscht.",
    setStatus: "Status setzen…",
    statusUpdated: "{{count}} aktualisiert.",
    exported: "{{count}} Zeilen exportiert.",
    actionError: "Die Sammelaktion ist fehlgeschlagen.",
  },
  pagination: {
    prev: "Zurück",
    next: "Weiter",
    pageOf: "Seite {{page}} von {{total}}",
  },
  actions: {
    downloadCv: "Lebenslauf öffnen",
    noCv: "Kein CV",
    noProfile: "—",
    notesPlaceholder: "Interne Notizen…",
    saveNotes: "Speichern",
    cancel: "Abbrechen",
    save: "Speichern",
  },
  status: {
    pending: "Ausstehend",
    confirmed: "Bestätigt",
    unsubscribed: "Abgemeldet",
    new: "Neu",
    screening: "Sichtung",
    interview: "Interview",
    offer: "Angebot",
    rejected: "Abgelehnt",
    contacted: "Kontaktiert",
    qualified: "Qualifiziert",
    closed: "Geschlossen",
    active: "Aktiv",
    trialing: "Test",
    past_due: "Überfällig",
    canceled: "Gekündigt",
    incomplete: "Unvollständig",
    none: "—",
  },
  // hr-applicants-sync v1 Lifecycle (qadar-hr LIFECYCLE_STATES — Kontrakt-Enum, #216)
  hrStatus: {
    received: "Eingegangen",
    acknowledged: "Bestätigt",
    docs_pending: "Unterlagen ausstehend",
    docs_complete: "Unterlagen vollständig",
    awaiting_founder_decision: "Entscheidung ausstehend",
    decided: "Entschieden",
    corresponded: "Korrespondiert",
    withdrawn: "Zurückgezogen",
    archived: "Archiviert",
    deleted: "Gelöscht",
  },
  hrSource: {
    careers_form: "Formular",
    careers_mail: "E-Mail",
  },
  hrCorrespondence: {
    acknowledgment: "Eingangsbestätigung",
    rejection: "Absage",
    on_hold_talent_pool: "On hold (Talent-Pool)",
    offer_announcement: "Angebots-Ankündigung",
  },
  hr: {
    managedByHr: "Verwaltet vom HR-Sync — Status-Updates kommen aus dem HR-System.",
    syncStale: "Letzter Sync vor mehr als {{hours}} h",
    openDossier: "Drive-Dossier öffnen",
    noDossier: "Noch kein Dossier-Link",
    noCorrespondence: "Noch keine Korrespondenz",
    openArchivedMessage: "Archivierte Nachricht im Drive-Dossier öffnen",
  },
  desc: {
    customers: "Organisationen aus der Shield-Plattform.",
    users: "Operator-Übersicht aller Nutzer über alle Shield-Organisationen. Über „Kunde einladen“ legst du eine neue Kunden-Org an — der Eingeladene wird ihr erster Admin.",
    newsletter: "Newsletter-Abonnenten (Double-Opt-in).",
    applications: "Bewerbungen von den Karriereseiten.",
    leads: "Kontaktanfragen von der Website.",
    gated: "Gated-Content-Leads (AI-Risiko-Report) — Enrichment + Drip-Status.",
    downloadNotify: "Launch-Benachrichtigungs-Anmeldungen von der /download-Seite — wer welche Plattform will.",
    helpFeedback: "„War das hilfreich?“-Stimmen aus dem Hilfe-Center — Score pro Artikel und Leser-Kommentare.",
    invites: "Offene Einladungen in bestehende Organisationen. Lädt einen Nutzer mit Rolle in eine bestehende Kunden-Org ein (Concierge / im Auftrag des Kunden). Teammates laden Kunden normalerweise selbst in der Shield-App ein.",
    accessRequests: "Warteliste-Anfragen aus dem Invite-only-Signup.",
    signupCodes: "Kohorten-Signup-Codes — feste Org, Nutzungslimit, Ablauf.",
    members: "Console-Admins. Mitarbeitende einladen und Zugriff verwalten.",
    seo: "Keyword-Rankings für die Website.",
    keywords: "Recherchierte Keywords (ATP / Sistrix) mit kanonischem Volumen, Intent und GSC-Position. Jedem eine Ziel-URL zuweisen.",
    questions: "People-Also-Ask-Antwort-Queue – Status, Modus und Antwort-URL pro Frage setzen.",
    reviews: "Shield-Web-Bewertungslinks erzeugen, exportieren und den Funnel verfolgen.",
    revenue: "Umsatz und Abos aus Stripe.",
    usage: "Nutzung und Adoption über alle Oberflächen — nur Aggregate, keine Einzelpersonen-Präsenz.",
    agents: "Firstier-Agentenplattform — Register, Läufe, Budget und Kill-Switch.",
  },
  review: {
    mintTitle: "Bewertungs-Einladungen erzeugen",
    mintHint: "Ein Empfänger pro Zeile: E-Mail — oder Name, E-Mail, Telefon, Sprache (en/de).",
    recipients: "Empfänger",
    recipientsPlaceholder: "jane@example.com\nBob, bob@example.com, +49 30 1234567, de",
    sendEmail: "E-Mail jetzt senden",
    sendEmailHint: "Sendet jedem Empfänger mit E-Mail-Adresse eine transaktionale E-Mail.",
    mint: "Einladungen erzeugen",
    parsedCount: "{{count}} Empfänger erkannt",
    noRecipients: "Pro Zeile mindestens E-Mail oder Telefon angeben.",
    mintError: "Erzeugen fehlgeschlagen.",
    notConfigured: "Erzeugen ist noch nicht konfiguriert (Backend-Secret fehlt).",
    resultTitle: "Erzeugt ({{count}})",
    copyLinks: "Links kopieren",
    exportCsv: "CSV exportieren",
    copied: "In die Zwischenablage kopiert.",
    colRecipient: "Empfänger",
    colChannel: "Kanal",
    colLink: "Bewertungslink",
    colVariant: "Variante",
    reusedBadge: "Wiederverwendet",
    sentBadge: "Gesendet",
    templateTitle: "E-Mail-Broadcast-Vorlage",
    templateHint: "Resend-Broadcast-HTML mit dem Platzhalter {{field}}.",
    templateLocale: "Sprache",
    copyTemplate: "Vorlagen-HTML kopieren",
    templateCopied: "Vorlagen-HTML kopiert.",
    templateError: "Vorlage konnte nicht geladen werden.",
    funnelTitle: "Funnel",
    ctr: "Klickrate",
    total: "Einladungen gesamt",
    status: { sent: "Gesendet", opened: "Geöffnet", clicked: "Geklickt", done: "Erledigt", unsubscribed: "Abgemeldet" },
    invitesTitle: "Einladungen",
    colStatus: "Status",
    colSentAt: "Erstellt",
    colOpenedAt: "Geöffnet",
    colClickedAt: "Geklickt",
    variantsTitle: "Varianten-Pool",
    colAngle: "Angle",
    colLocale: "Sprache",
    colUsage: "Nutzungen",
    colActive: "Aktiv",
    activeBadge: "Aktiv",
    inactiveBadge: "Inaktiv",
    poolWarning: "Dünner Varianten-Pool für {{locale}} ({{count}} aktiv) — mehr review_variants anlegen, um wiederverwendete Entwürfe zu vermeiden.",
  },
  invites: {
    countBadge: "{{count}} offen",
    colEmail: "E-Mail",
    colOrg: "Organisation",
    colRole: "Rolle",
    colExpires: "Läuft ab",
    colInvited: "Eingeladen",
    revoke: "Widerrufen",
    revokeTitle: "Einladung widerrufen",
    revokeDesc: "Einladung für „{{email}}“ widerrufen? Der Link funktioniert sofort nicht mehr.",
    revoked: "Einladung widerrufen.",
    resend: "E-Mail erneut senden",
    resent: "Einladungs-E-Mail erneut gesendet.",
    resendStub: "E-Mail-Versand wartet auf die repo-übergreifende Anbindung (shield-control send-invite).",
    emailPendingBadge: "E-Mail ausstehend",
    arCountBadge: "{{count}} Anfragen",
    colName: "Name",
    colCompany: "Unternehmen",
    colNote: "Notiz",
    colStatus: "Status",
    colRequested: "Angefragt",
    arStatus: { pending: "Offen", invited: "Eingeladen", rejected: "Abgelehnt" },
    reject: "Ablehnen",
    requestRejected: "Anfrage abgelehnt.",
    invite: "Einladen",
    inviteTitle: "In eine Organisation einladen",
    inviteOrg: "Organisation",
    inviteRole: "Rolle",
    inviteHint: "Erstellt eine Einladung in die gewählte Org und sendet den Link per E-Mail.",
    inviteCreate: "Einladung erstellen",
    inviteCreated: "Einladung gesendet.",
    inviteCreatedNoEmail: "Einladung erstellt, aber die E-Mail konnte nicht gesendet werden — bitte erneut senden.",
    alreadyInvited: "{{email}} hat bereits eine offene Einladung — wir haben sie aufgefrischt.",
    scCountBadge: "{{count}} Codes",
    colCode: "Code",
    colUses: "Nutzungen",
    colExpiry: "Ablauf",
    colCreated: "Erstellt",
    create: "Neuer Code",
    createTitle: "Signup-Code erstellen",
    codeLabel: "Code",
    codePlaceholder: "KOHORTE-2026",
    maxUses: "Max. Nutzungen",
    maxUsesHint: "Leer = unbegrenzt.",
    expiry: "Ablauf (optional)",
    createBtn: "Code erstellen",
    codeCreated: "Signup-Code erstellt.",
    revokeCode: "Widerrufen",
    revokeCodeTitle: "Signup-Code widerrufen",
    revokeCodeDesc: "Code „{{code}}“ widerrufen? Er kann nicht mehr eingelöst werden.",
    codeRevoked: "Code widerrufen.",
    revokedBadge: "Widerrufen",
    activeBadge: "Aktiv",
    unlimited: "Unbegrenzt",
    noExpiry: "Kein Ablauf",
    actionError: "Die Aktion ist fehlgeschlagen.",
  },
  gated: {
    colCompany: "Unternehmen",
    colAsset: "Asset",
    colRisk: "Risiko",
    colStatus: "Status",
    colDrip: "Drip",
    status: { pending: "Ausstehend", confirmed: "Bestätigt" },
    drip: { none: "Keiner", scheduled: "Geplant", stopped: "Gestoppt", completed: "Abgeschlossen" },
    risk: { Elevated: "Erhöht", High: "Hoch", Moderate: "Mittel", Low: "Niedrig" },
    dripAutoStart: "Drip automatisch starten",
    dripAutoStartHint: "Wenn aktiv, durchlaufen neue bestätigte Leads die Drip-Sequenz automatisch.",
    dripAutoStartSaved: "Einstellung gespeichert.",
    payloadTitle: "Rechner-Eingaben",
    enrichmentTitle: "Unternehmens-Enrichment",
    actionsTitle: "Aktionen",
    fieldAsset: "Asset",
    fieldDomain: "Domain",
    fieldCreated: "Erstellt",
    fieldConfirmed: "Bestätigt",
    fieldLocale: "Sprache",
    fieldConsent: "Marketing-Einwilligung",
    fieldRevenueStep: "Umsatzstufe",
    fieldCompanySize: "Unternehmensgröße",
    fieldAiMaturity: "AI-Reife",
    fieldRisk: "Risikostufe",
    fieldCompanyName: "Unternehmensname",
    fieldIndustry: "Branche",
    fieldDescription: "Beschreibung",
    openHomepage: "Webseite",
    openScreenshot: "Screenshot",
    openReport: "Report-PDF",
    noEnrichment: "Noch keine Enrichment-Daten.",
    actionDrip: "Drip starten",
    actionStopDrip: "Drip stoppen",
    actionResend: "Report erneut senden",
    actionPromote: "Zu Lead befördern",
    promoteDone: "In die Sales-Pipeline übernommen.",
    promoteAlready: "Diese E-Mail ist bereits ein Lead.",
    alreadyLead: "Bereits in der Sales-Pipeline.",
    leadBadge: "Lead",
    dripNoConsent: "Lead hat keine Marketing-Einwilligung — Drip kann nicht gestartet werden.",
    dripDone: {
      start: "Drip-Sequenz geplant.",
      stop: "Drip-Sequenz gestoppt.",
      resend: "Report erneut gesendet.",
    },
  },
  orgs: {
    searchPlaceholder: "Organisationen durchsuchen…",
    filterPlan: "Plan",
    filterStatus: "Abo",
    viewActive: "Aktiv",
    viewArchived: "Archiviert",
    countBadge: "{{count}} Organisationen",
    colOrganization: "Organisation",
    colPlan: "Plan",
    colSubscription: "Abo",
    colMembers: "Mitglieder",
    colIndustry: "Branche",
    colCreated: "Erstellt",
    edit: "Bearbeiten",
    delete: "Löschen",
    restore: "Wiederherstellen",
    restored: "Organisation wiederhergestellt.",
    saved: "Organisation gespeichert.",
    deletedToast: "Organisation archiviert. Stripe-Abos wurden gekündigt.",
    purgedToast: "Organisation endgültig gelöscht.",
    usersLink: "Nutzer: {{count}}",
    policiesLink: "Richtlinien",
    slideoutTitle: "Organisation bearbeiten",
    fieldName: "Name",
    fieldDomain: "Domain",
    fieldIndustry: "Branche",
    fieldPlan: "Plan",
    fieldPolicyMode: "Standard-Policy-Modus",
    policyModeHint: "Wirkt sofort — das ist die Live-Enforcement-Einstellung von Shield.",
    fieldShowUserList: "Nutzerliste anzeigen",
    fieldContentDetection: "Content-Erkennung",
    billingTitle: "Billing",
    billingHint: "Verwaltet in Stripe (Source of Truth). Änderungen laufen über die Aktionen unten; die Anzeige kann wenige Sekunden nachlaufen.",
    billingPending: "Synchronisiert…",
    billingActionOk: "Erledigt — Stripe synchronisiert.",
    billingNoCustomer: "Noch kein Stripe-Kunde verknüpft.",
    billingNoSubscription: "kein Abo",
    billingRenewsAt: "verlängert am {{date}}",
    billingCancelsAt: "endet am {{date}}",
    billingSeats: "{{count}} Seats",
    billingInterval: "Abrechnungsintervall",
    billingInterval_annual: "Jährlich",
    billingInterval_monthly: "Monatlich",
    billingChangePlan: "Plan ändern",
    billingStart: "Abo starten",
    billingLinkCustomer: "Stripe-Kunden verknüpfen",
    billingLinkPlaceholder: "cus_… (leer = neuen Kunden anlegen)",
    billingCancel: "Abo kündigen",
    billingCancelTitle: "Abo kündigen",
    billingCancelDesc: "\"{{name}}\" behält Zugriff bis {{date}}, danach endet das Abo. Stripe stoppt die Abrechnung automatisch.",
    dangerZone: "Gefahrenbereich",
    selectAllMatching: "Alle {{count}} passenden Kunden auswählen",
    allMatchingSelected: "Alle {{count}} passenden Kunden ausgewählt",
    archive: "Archivieren",
    softDeleteTitle: "Organisation archivieren",
    softDeleteDesc: "\"{{name}}\" wird aus der aktiven Liste ausgeblendet, Stripe-Abos werden sofort gekündigt. Wiederherstellung innerhalb von 30 Tagen möglich; danach endgültige Löschung.",
    bulkDeleteTitle_one: "{{count}} Kunden archivieren?",
    bulkDeleteTitle_other: "{{count}} Kunden archivieren?",
    bulkDeleteDesc_one: "{{count}} Organisation wird aus der aktiven Liste ausgeblendet, ihre Stripe-Abos werden sofort gekündigt. Wiederherstellung innerhalb von 30 Tagen möglich; danach endgültige Löschung.",
    bulkDeleteDesc_other: "{{count}} Organisationen werden aus der aktiven Liste ausgeblendet, ihre Stripe-Abos werden sofort gekündigt. Wiederherstellung innerhalb von 30 Tagen möglich; danach endgültige Löschung.",
    bulkDeletedToast_one: "{{count}} Organisation archiviert. Stripe-Abos wurden gekündigt.",
    bulkDeletedToast_other: "{{count}} Organisationen archiviert. Stripe-Abos wurden gekündigt.",
    purgeAction: "Endgültig löschen",
    purgeTitle: "Organisation endgültig löschen",
    purgeDesc: "Alle Daten von \"{{name}}\" — Policies, Apps, Audit-Historie und alle Mitglieder-Konten — werden endgültig gelöscht. Das kann nicht rückgängig gemacht werden.",
    purgeNotSoftDeleted: "Erst archivieren — endgültiges Löschen setzt eine vorherige Archivierung voraus.",
    typeToConfirm: "Zur Bestätigung {{value}} eingeben",
    archivedBadge: "Archiviert",
    demoBadge: "Demo",
    domainsTitle: "Domains",
    domainVerified: "Verifiziert",
    domainPending: "Ausstehend",
    domainPrimary: "Primär",
    domainsBadge: "{{verified}}/{{count}} Domains",
    domainsEmpty: "Noch keine Domains beansprucht.",
    domainsTransferNote: "Domains werden durch Kundenverifizierung in Shield gesetzt. Zum Neuzuweisen einer verifizierten Domain den Staff-Domain-Transfer verwenden (shield-control#268).",
    growthTitle: "Kundenwachstum",
  },
  policies: {
    pageTitle: "{{org}} · Richtlinien",
    pageDescription: "Shield-Richtlinien dieser Organisation in ihrem Auftrag ansehen und bearbeiten.",
    new: "Neue Richtlinie",
    create: "Richtlinie erstellen",
    edit: "Richtlinie bearbeiten",
    createDesc: "Tool-spezifische Richtlinien gelten zusätzlich zu allgemeinen; bei Konflikt gewinnt die strengere Aktion.",
    createBtn: "Richtlinie erstellen",
    emptyTitle: "Noch keine Richtlinien",
    emptyDesc: "Erstelle die erste Richtlinie für diese Organisation. Allgemeine Richtlinien gelten für alle Tools; tool-spezifische zielen auf einzelne AI-Apps.",
    generalSection: "Allgemeine Richtlinien",
    generalSectionDesc: "Gelten für alle Tools.",
    generalEmpty: "Noch keine allgemeinen Richtlinien.",
    specificSection: "Tool-spezifische Richtlinien",
    specificSectionDesc: "Auf einzelne AI-Apps beschränkt.",
    specificEmpty: "Noch keine tool-spezifischen Richtlinien.",
    appliesTo: "Gilt für",
    appliesToLabel: "Gilt für:",
    allTools: "Alle Tools",
    unknownTool: "Unbekanntes Tool",
    scopeAll: "Alle Tools",
    scopeSpecific: "Bestimmte Tools",
    specificTools: "Tools",
    pickTools: "AI-Apps auswählen…",
    pickAtLeastOne: "Mindestens ein Tool auswählen.",
    precedenceHint: "Tool-spezifische Richtlinien gelten zusätzlich zu allgemeinen; bei Konflikt gewinnt die strengere Aktion.",
    name: "Name",
    namePlaceholder: "z. B. Quellcode-Uploads blockieren",
    nameTooShort: "Der Name muss mindestens 2 Zeichen haben.",
    descLabel: "Beschreibung",
    dataTypes: "Datentypen",
    actions: "Aktionen",
    enforcement: "Durchsetzung",
    pausedTag: "Pausiert",
    activated: "Richtlinie aktiviert.",
    paused: "Richtlinie pausiert.",
    created: "Richtlinie erstellt.",
    updated: "Richtlinie aktualisiert.",
    deleted: "Richtlinie gelöscht.",
    delete: "Löschen",
    deleteTitle: "Richtlinie löschen",
    deleteDesc: "Richtlinie \"{{name}}\" löschen? Damit entfällt ihre Durchsetzung; dies kann nicht rückgängig gemacht werden.",
    deleteConfirm: "Richtlinie löschen",
    layoutTable: "Tabellenansicht",
    layoutSections: "Abschnittsansicht",
    statusActive: "Aktiv",
    statusPaused: "Pausiert",
    data: {
      pii: "PII (Personenbezogene Daten)",
      phi: "PHI (Gesundheitsdaten)",
      financial: "Finanzdaten",
      source_code: "Source Code",
      contracts: "Verträge",
      secrets: "Secrets / Credentials",
      piiHint: "E-Mail, Telefon, Personalausweis, Steuer-ID. IBAN & Kartennummern fallen unter Finanzdaten.",
      financialHint: "IBAN, Kredit-/Debitkarte, BIC/SWIFT, Bankleitzahlen — nicht PII.",
      source_codeHint: "Codeblöcke, Funktions-/Klassendefinitionen, Skript-Syntax.",
      secretsHint: "API-Schlüssel, Access-Tokens, JWTs, private Schlüssel.",
      unsupportedHint: "Erkennung folgt in Kürze.",
    },
    act: {
      prompt: "Prompt absenden",
      upload: "Datei hochladen",
      paste: "Copy / Paste",
      download: "Download",
      share: "Share / Open-in",
      promptHint: "Absenden einer Chat-Nachricht an das AI-Tool.",
      uploadHint: "Hochladen einer Datei in das AI-Tool.",
      pasteHint: "Einfügen von Inhalten in das AI-Tool.",
      downloadHint: "Herunterladen generierter Inhalte.",
      shareHint: "Teilen bzw. Öffnen in einer anderen App.",
    },
    enf: {
      observe: "Beobachten",
      warn: "Warnen",
      justify: "Begründen",
      transform: "Transformieren",
      block: "Blockieren",
    },
    fieldTip: {
      appliesTo: "Legt fest, ob die Richtlinie für alle AI-Tools oder nur bestimmte gilt. Tool-spezifische Richtlinien ergänzen allgemeine; bei Konflikt gewinnt die strengere Aktion.",
      tools: "Die konkreten AI-Tools, auf die diese Richtlinie zielt. Nur relevant, wenn „Gilt für“ auf bestimmte Tools gesetzt ist.",
      name: "Ein kurzer, eindeutiger Name. Wird aus deiner Auswahl vorbefüllt, bis du ihn bearbeitest.",
      description: "Optionaler Kontext, der erklärt, was die Richtlinie tut. Wird aus deiner Auswahl vorbefüllt, bis du sie bearbeitest.",
      dataTypes: "Die Inhaltstypen, auf die diese Richtlinie achtet, on-device erkannt. Typen ohne Detektor sind deaktiviert.",
      actions: "Die Nutzeraktionen, die diese Richtlinie erfasst — Prompt senden, Datei hochladen, Einfügen, Download oder Teilen.",
      enforcement: "Was bei einem Treffer passiert: beobachten (nur protokollieren), warnen, begründen, redigieren oder blockieren.",
    },
    autoName: {
      allUsage: "alle AI-Nutzung",
      blockTool: "{{tool}} blockieren",
      enf: {
        observe: "{{data}} beobachten",
        warn: "Warnen bei {{data}}",
        justify: "{{data}} begründen",
        transform: "{{data}} redigieren",
        block: "{{data}} blockieren",
      },
      dt: {
        pii: "PII",
        financial: "Finanzdaten",
        source_code: "Quellcode",
        secrets: "Secrets",
        contracts: "Verträge",
        phi: "PHI",
      },
    },
    autoDesc: {
      allActivity: "jede AI-Nutzung",
      targetAll: "in allen AI-Tools",
      targetTool: "in {{tool}}",
      targetTools: "in den ausgewählten Tools",
      blockTool: "Blockiert die gesamte Nutzung von {{tool}}.",
      enf: {
        observe: "Protokolliert {{data}} {{target}}.",
        warn: "Warnt bei {{data}} {{target}}.",
        justify: "Erfordert eine Begründung für {{data}} {{target}}.",
        transform: "Redigiert {{data}} {{target}}.",
        block: "Blockiert {{data}} {{target}}.",
      },
    },
  },
  policiesTable: {
    search: "Richtlinien suchen…",
    filterEnforcement: "Durchsetzung",
    filterStatus: "Status",
    columns: "Spalten",
    emptyTitle: "Noch keine Richtlinien",
    emptyDesc: "Erstellen Sie die erste Richtlinie für diesen Kunden.",
    noHitsTitle: "Keine Richtlinien gefunden",
    noHitsDesc: "Keine Richtlinien entsprechen den Filtern. Setzen Sie sie zurück oder erstellen Sie eine neue Richtlinie.",
    clearFilters: "Filter zurücksetzen",
    exportCsv: "CSV exportieren",
    exported: "{{count}} Richtlinien exportiert.",
    col: {
      name: "Name",
      enforcement: "Durchsetzung",
      applies: "Gilt für",
      data: "Datentypen",
      actions: "Aktionen",
      status: "Status",
      version: "Version",
      created: "Erstellt",
      modified: "Zuletzt geändert",
    },
    tip: {
      name: "Der Name der Richtlinie und ihre Beschreibung.",
      enforcement: "Wie die Richtlinie bei einem Treffer wirkt: beobachten, warnen, begründen, transformieren oder blockieren.",
      applies: "Auf welche AI-Tools die Richtlinie zielt – alle Tools oder bestimmte.",
      data: "Datentypen, die die Richtlinie regelt (z. B. PII, Geheimnisse, Quellcode).",
      actions: "Nutzeraktionen, die die Richtlinie regelt (z. B. Prompt, Upload, Einfügen).",
      status: "Ob die Richtlinie derzeit aktiv oder pausiert ist.",
      version: "Erhöht sich bei jeder Bearbeitung der Richtlinie.",
      created: "Wann die Richtlinie erstellt wurde.",
      modified: "Wann die Richtlinie zuletzt bearbeitet wurde.",
    },
  },
  users: {
    countBadge: "{{count}} Nutzer",
    filterOrg: "Organisation",
    filterRole: "Rolle",
    colOrg: "Organisation",
    invite: "Kunde einladen",
    addUser: "Nutzer hinzufügen",
  },
  addUser: {
    title: "Nutzer hinzufügen",
    hint: "In eine bestehende Organisation einladen oder eine neue Kunden-Org anlegen.",
    org: "Organisation",
    orgPlaceholder: "Organisation wählen…",
    newOrg: "➕ Neue Organisation",
    demoBadge: "Demo",
    industry: "Branche (optional)",
    plan: "Plan",
    locale: "Sprache der Einladung",
    submit: "Hinzufügen",
    button: "Nutzer hinzufügen",
  },
  industry: {
    label: "Branche",
    placeholder: "Branchen suchen…",
    otherLabel: "Branche (Sonstige)",
    otherPlaceholder: "Branche eingeben…",
    technology_software: "Technologie / Software",
    financial_services: "Finanzdienstleistungen / Banking",
    insurance: "Versicherung",
    healthcare: "Gesundheitswesen",
    pharma_biotech: "Pharma / Biotech",
    manufacturing: "Fertigung / Industrie",
    retail_ecommerce: "Handel / E-Commerce",
    professional_services: "Professional Services / Beratung",
    legal: "Recht",
    media_entertainment: "Medien / Unterhaltung",
    telecommunications: "Telekommunikation",
    energy_utilities: "Energie / Versorgung",
    real_estate: "Immobilien",
    transportation_logistics: "Transport / Logistik",
    travel_hospitality: "Reise / Gastgewerbe",
    education: "Bildung",
    government_public: "Öffentlicher Sektor",
    nonprofit: "Non-Profit / NGO",
    automotive: "Automobil",
    construction_engineering: "Bau / Ingenieurwesen",
    aerospace_defense: "Luft- & Raumfahrt / Verteidigung",
    agriculture: "Landwirtschaft",
    marketing_advertising: "Marketing / Werbung",
    other: "Sonstige",
  },
  inviteCustomer: {
    title: "Kunde einladen",
    description:
      "Wir senden ihm einen sicheren Anmeldelink per E-Mail. Bei der ersten Anmeldung erstellen wir seine Organisation und machen ihn zu deren Admin.",
    emailLabel: "Kunden-E-Mail",
    orgLabel: "Organisationsname",
    orgHint: "Aus der E-Mail-Domain vorausgefüllt — bei Bedarf anpassen.",
    orgPlaceholder: "Acme GmbH",
    submit: "Einladung senden",
    sent: "Einladung an {{email}} gesendet.",
    alreadyRegistered: "Für diese E-Mail existiert bereits ein Konto.",
    error: "Die Einladung konnte nicht gesendet werden.",
    errorDetail: "Die Einladung konnte nicht gesendet werden: {{detail}}",
  },
  orgUsers: {
    title: "Nutzer — {{org}}",
    description: "Mitglieder dieser Organisation.",
    searchPlaceholder: "Nutzer durchsuchen…",
    colUser: "Nutzer",
    colRole: "Rolle",
    colLocale: "Sprache",
    colJoined: "Beigetreten",
    colLastSignIn: "Letzte Anmeldung",
    role: { admin: "Admin", security: "Security", auditor: "Auditor", member: "Mitglied", none: "—" },
    slideoutTitle: "Nutzer bearbeiten",
    fieldFullName: "Vollständiger Name",
    fieldRole: "Rolle",
    fieldEmail: "E-Mail",
    saved: "Nutzer gespeichert.",
    deleteTitle: "Nutzerkonto löschen",
    deleteDesc: "\"{{email}}\" verliert dauerhaft den Zugang: Profil, Rolle und Login-Konto werden gelöscht. Das kann nicht rückgängig gemacht werden.",
    deletedToast: "Nutzerkonto gelöscht.",
    backToCustomers: "Alle Kunden",
  },
  settings: {
    title: "Einstellungen",
    description: "Verwalte dein Konto.",
    tabs: { profile: "Profil", security: "Sicherheit", preferences: "Präferenzen" },
    name: "Anzeigename",
    nameDesc: "Wird in der Console für dein Konto angezeigt.",
    namePlaceholder: "Dein Name",
    email: "E-Mail",
    emailDesc: "Die Adresse, mit der du dich anmeldest.",
    emailChangeHint: "E-Mail im Tab Sicherheit ändern.",
    save: "Speichern",
    saved: "Gespeichert.",
    changeEmail: "E-Mail ändern",
    changeEmailDesc: "Wir senden einen Bestätigungslink an die neue Adresse, bevor die Änderung wirksam wird.",
    newEmail: "Neue E-Mail",
    sendConfirmation: "Bestätigung senden",
    emailChangeSent: "Bestätigung gesendet. Prüfe das neue Postfach, um die Änderung abzuschließen.",
    changePassword: "Passwort ändern",
    changePasswordDesc: "Mindestens 8 Zeichen verwenden.",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordMismatch: "Passwörter stimmen nicht überein.",
    updatePassword: "Passwort aktualisieren",
    passwordUpdated: "Passwort aktualisiert.",
    signOutAll: "Überall abmelden",
    signOutAllDesc: "Beende alle Sitzungen auf allen Geräten, inkl. dieser.",
    signOutAllBtn: "Alle Sitzungen abmelden",
    language: "Sprache",
    languageDesc: "Console-Sprache für dein Konto.",
    errorGeneric: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  },
  members: {
    invite: "Einladen",
    inviteLabel: "Teammitglied per E-Mail einladen",
    invited: "Einladung gesendet.",
    inviteError: "Einladung konnte nicht gesendet werden.",
    emailNotAllowed: "Nur Firstier-Mitarbeiteradressen können eingeladen werden.",
    statusInvited: "Eingeladen",
    statusActive: "Aktiv",
    lastSignIn: "Letzte Anmeldung",
    remove: "Entfernen",
    removed: "Mitglied entfernt.",
    removeError: "Mitglied konnte nicht entfernt werden.",
    you: "Du",
  },
  placeholder: {
    comingSoon: "Demnächst verfügbar",
    description: "Dieser Bereich gehört zum Console-Grundgerüst und wird als Nächstes an Live-Daten angebunden.",
  },
  error: {
    title: "Etwas ist schiefgelaufen",
    description: "Beim Rendern dieser Seite ist ein unerwarteter Fehler aufgetreten.",
    technical: "Technische Details",
    goHome: "Zum Dashboard",
    tryAgain: "Erneut versuchen",
  },
  notFound: {
    title: "Seite nicht gefunden",
    description: "Die gesuchte Seite existiert nicht.",
    goHome: "Zum Dashboard",
  },
  playground: {
    title: "Datentypen",
    copy: "Prompt kopieren",
    layoutFull: "Vollansicht",
    layoutSimple: "Einfache Ansicht",
    simple: {
      heading: "Beispiel-Prompt",
    },
    description: "Demo- und Test-Prompts für die Shield-Datentyp-Detektoren. Die Prompts sind Copy-paste-Material — verifiziert gegen die Shield-Web-Detektoren.",
    nav: {
      label: "Abschnitte",
      combined: "Kombinierter Generator",
    },
    combined: {
      heading: "Kombinierter Generator",
      description: "Wähle die einzubeziehenden Datentypen; der Prompt unten wird deterministisch erzeugt — ein Fragment pro ausgewähltem Typ. Kopiere ihn direkt in einen Chat, um die Erkennung zu testen.",
    },
    status: {
      live: "Live (v0.1.8)",
      preview: "v0.1.11 (CWS-Review)",
      backlog: "Noch kein Detektor (Backlog #312)",
    },
    type: {
      pii: "PII",
      financial: "Finanzdaten",
      secrets: "Secrets",
      source_code: "Quellcode",
      phi: "PHI",
      contracts: "Verträge",
    },
    desc: {
      pii: "Erkennt E-Mail, Telefon (mit +/()-Form), US-SSN (Form 123-45-6789) und deutsche Steuer-ID (Prüfsumme MOD 11,10). Empfohlene Durchsetzung: Transform (maskieren / pseudonymisieren).",
      financial: "Prüfsummen-gestützt: IBAN (mod-97), Kredit-/Debitkarte (Luhn), BIC/SWIFT-Struktur und US-ABA-Routing (mod-10). Empfohlene Durchsetzung: Transform.",
      secrets: "Regex für API-Key-Formen (sk-…, AKIA…), JWTs und PEM-Private-Key-Blöcke. Empfohlene Durchsetzung: Transform (vor dem Senden schwärzen).",
      source_code: "Heuristik — greift bei einem umzäunten Codeblock oder ≥3 Code-Schlüsselwörtern/Klammern. Empfohlene Durchsetzung: Block oder Warnung (Transform schwärzt niemals Code).",
      phi: "Noch kein Detektor (Backlog #312) — Gesundheitsdaten wie Diagnosen, HbA1c/Laborwerte und Medikamente werden heute NICHT erkannt.",
      contracts: "Noch kein Detektor (Backlog #312) — Vertrags- und Rechtsklauseln werden heute NICHT erkannt.",
    },
    example: {
      pii1: "E-Mail + Telefon",
      pii2: "SSN + Steuer-ID",
      pii3: "Gemischt",
      financial1: "IBAN",
      financial2: "Karte + BIC",
      financial3: "Routing + gemischt",
      secrets1: "API-Keys",
      secrets2: "JWT",
      secrets3: "Private Key",
      sourceJs: "JavaScript",
      sourcePython: "Python",
      sourceSql: "SQL",
      phi1: "Diagnose",
      phi2: "Entlassung",
      phi3: "Laborwert",
      contracts1: "NDA",
      contracts2: "Kündigung",
      contracts3: "Haftung",
    },
  },
} as const;

export default de;
